import script from "./GuideView.vue?vue&type=script&lang=ts&setup=true"
export * from "./GuideView.vue?vue&type=script&lang=ts&setup=true"

import "./GuideView.vue?vue&type=style&index=0&id=5df62b62&scoped=true&lang=scss"

import exportComponent from "/Users/jnshul/Documents/tagluffa_i_vue3/main_page/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5df62b62"]])

export default __exports__